// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-radio-group[data-v-29d3ab2e]{display:flex;gap:16px}.x-radio-group-label-row[data-v-29d3ab2e]{margin-top:4px}.x-radio-group[data-v-29d3ab2e] .v-input--selection-controls{margin-top:0}.x-radio-group[data-v-29d3ab2e] .v-input--radio-group__input{gap:10px}.x-radio-group[data-v-29d3ab2e] .help-button{margin-top:2px}", ""]);
// Exports
module.exports = exports;
